export enum ResidentsRequestTypeEnum{
    ServiceRequest = "ServiceRequest",
    WaitingList = "WaitingList"
  }